export type AuthMethod = "google" | "whatsapp";

const ALL_METHODS: readonly AuthMethod[] = ["google", "whatsapp"];

export const DEFAULT_AUTH_METHODS: readonly AuthMethod[] = ["google"];

/**
 * Parse a comma-separated list of auth methods, filtering out unknown values
 * and de-duplicating. Returns `null` when nothing valid was provided so the
 * caller falls back to DEFAULT_AUTH_METHODS.
 */
export const parseAuthMethods = (
  raw: string | undefined | null
): AuthMethod[] | null => {
  if (!raw || !raw.trim()) {
    return null;
  }

  const requested = raw
    .split(",")
    .map((m) => m.trim().toLowerCase())
    .filter(Boolean);

  const valid = requested.filter((m): m is AuthMethod =>
    (ALL_METHODS as readonly string[]).includes(m)
  );

  return valid.length > 0 ? Array.from(new Set(valid)) : null;
};

export const config = {
  loginApiUrl: import.meta.env.VITE_LOGIN_API_URL ?? "",
  redirectUrl: import.meta.env.VITE_REDIRECT_URL ?? "",
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  allowedRedirectDomains: Array.from(
    new Set(
      (import.meta.env.VITE_ALLOWED_REDIRECT_DOMAINS ?? "")
        .split(",")
        .map((domain) => domain.trim().toLowerCase())
        .filter(Boolean)
    )
  ).map((domain) => {
    try {
      // Normalize to punycode to avoid homograph bypasses
      return new URL(`https://${domain}`).hostname.toLowerCase();
    } catch {
      return domain;
    }
  }),
};
